import { VersionedTransaction } from "@solana/web3.js";
export class SwapRequest {
    route;
    userPublicKey;
    priorityFee;
    constructor(route, userPublicKey, priorityFee) {
        this.route = route;
        this.userPublicKey = userPublicKey;
        this.priorityFee = priorityFee;
    }
}
export class SwapResponse {
    setupTransactions;
    cleanupTransactions;
    swapTransactions;
    constructor(txns) {
        this.cleanupTransactions = txns;
        this.swapTransactions = txns;
        this.setupTransactions = txns;
    }
    toSetupTransactions() {
        return this._toTransactions(this.setupTransactions);
    }
    toSwapTransactions() {
        return this._toTransactions(this.swapTransactions);
    }
    toCleanupTransactions() {
        return this._toTransactions(this.cleanupTransactions);
    }
    _toTransactions(tx) {
        const txns = [];
        for (let i = 0; i < tx.length; i++) {
            const txn = VersionedTransaction.deserialize(Buffer.from(tx[i], "base64"));
            txns.push(txn);
        }
        return txns;
    }
}
